<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.75" />
  <path
    d="M9.5 9.5C9.9 8.4 10.8 7.5 12 7.5C13.7 7.5 15 8.8 15 10.5C15 12.7 12 13.5 12 13.5V15"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
  <circle cx="12" cy="18" r="0.75" fill="currentColor" />
</svg>
